import { getApiEnvironment } from '../utils/getApiEnvironment';
import { getBearerAuth0Token } from '../utils/authUtils';
import { getTenantId } from '../storages/tenantId';
import { getService } from './getService';
import axios from 'axios';
import { getFeatureFlags, hasFeatureFlags } from '../storages/featureFlags';
export const axiosWithHeaders = ({ service, config = {}, environmentOverride = getApiEnvironment(), injectTenantId = true, axiosCreateOpts = { timeout: 6000 }, }) => {
    const options = {
        baseURL: getService(service, config, environmentOverride),
        ...axiosCreateOpts,
    };
    const api = axios.create(options);
    api.interceptors.request.use(conf => {
        const headers = { ...conf.headers };
        const tenantId = getTenantId();
        headers.Authorization = getBearerAuth0Token();
        if (injectTenantId && tenantId) {
            headers['X-Tenant-Id'] = tenantId;
        }
        conf.headers = headers;
        if (hasFeatureFlags()) {
            const featureFlags = getFeatureFlags();
            conf.baseURL = getService(service, config, environmentOverride, featureFlags);
        }
        return conf;
    }, error => {
        return Promise.reject(error);
    });
    return api;
};
